import { Dropdown } from "@circle-react-uikit/Dropdown";
import { FilterContainer } from "./FilterContainer";

interface Filter {
  availableLabel?: string;
  label: string;
  name: string;
}

interface FiltersListProps {
  filters: Filter[];
  onAddFilter: (name: string) => void;
  title: string;
}

export const FiltersList = ({
  filters,
  title,
  onAddFilter,
}: FiltersListProps) => {
  if (!filters.length) {
    return null;
  }

  return (
    <FilterContainer title={title}>
      {filters.map(({ name, label, availableLabel }) => (
        <Dropdown.ItemWithLink key={name} onClick={() => onAddFilter(name)}>
          {availableLabel ?? label}
        </Dropdown.ItemWithLink>
      ))}
    </FilterContainer>
  );
};
